import { useEffect, useState } from "react";

import { api } from "../api";

export const CLIENT_PORTAL_CONFIG_KEYS = Object.freeze({
  enabled: "CLIENT_PORTAL_ENABLED",
  claimEnabled: "CLIENT_PORTAL_CLAIM_ENABLED",
  authenticatedCheckoutEnabled:
    "CLIENT_PORTAL_AUTH_CHECKOUT_ENABLED",
});

export const DISABLED_CLIENT_PORTAL_CONFIG = Object.freeze({
  enabled: false,
  claimEnabled: false,
  authenticatedCheckoutEnabled: false,
});

function parseBoolean(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (value == null || value === "") return fallback;

  const normalized = String(value).trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) return true;
  if (["0", "false", "no", "off"].includes(normalized)) return false;
  return fallback;
}

function getWebsiteConfigRows(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.WebsiteConfigs)) return data.WebsiteConfigs;
  return [];
}

export function resolveClientPortalConfig(data) {
  const allowedKeys = Object.values(CLIENT_PORTAL_CONFIG_KEYS);
  const values = getWebsiteConfigRows(data).reduce((result, row) => {
    const key = String(row?.key || "").trim().toUpperCase();
    if (allowedKeys.includes(key)) result[key] = row?.value;
    return result;
  }, {});

  const enabled = parseBoolean(
    values[CLIENT_PORTAL_CONFIG_KEYS.enabled],
    false
  );

  return {
    enabled,
    claimEnabled:
      enabled &&
      parseBoolean(
        values[CLIENT_PORTAL_CONFIG_KEYS.claimEnabled],
        false
      ),
    authenticatedCheckoutEnabled:
      enabled &&
      parseBoolean(
        values[CLIENT_PORTAL_CONFIG_KEYS.authenticatedCheckoutEnabled],
        false
      ),
  };
}

export function useClientPortalConfig(
  loadConfig = api.getWebsiteIdentity
) {
  const [config, setConfig] = useState(() => ({
    ...DISABLED_CLIENT_PORTAL_CONFIG,
    ready: false,
  }));

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        const data = await loadConfig();
        if (active) {
          setConfig({
            ...resolveClientPortalConfig(data),
            ready: true,
          });
        }
      } catch (error) {
        if (active) {
          setConfig({
            ...DISABLED_CLIENT_PORTAL_CONFIG,
            ready: true,
          });
        }
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [loadConfig]);

  return config;
}

export { parseBoolean };
